<script setup>
import { useConsent } from '../composables/useConsent.js'

const { visible, accept, reject } = useConsent()
</script>

<template>
  <Transition name="rise">
    <div v-if="visible" class="consent" role="dialog" :aria-label="$t('consent.aria')">
      <div class="consent__body">
        <p class="consent__title">{{ $t('consent.title') }}</p>
        <p class="consent__text">{{ $t('consent.text') }}</p>
      </div>
      <div class="consent__actions">
        <button class="consent__btn consent__btn--ghost" @click="reject">{{ $t('consent.reject') }}</button>
        <button class="consent__btn consent__btn--solid" @click="accept">{{ $t('consent.accept') }}</button>
      </div>
    </div>
  </Transition>
</template>

<style scoped>
.consent {
  position: fixed; left: 0; right: 0; bottom: 0; z-index: 60;
  background: #0a0e1f; color: #fff; padding: var(--sp-4);
  padding-bottom: calc(var(--sp-4) + var(--safe-bottom));
  box-shadow: 0 -8px 24px rgba(0,0,0,.28);
}
.consent__title { margin: 0 0 4px; font-size: 15px; font-weight: var(--fw-semibold); }
.consent__text { margin: 0; font-size: 12px; line-height: 1.5; color: rgba(255,255,255,.78); }
.consent__actions { display: flex; gap: var(--sp-2); margin-top: var(--sp-3); }
.consent__btn { flex: 1; height: 40px; border-radius: var(--r-pill); font-size: 14px; font-weight: var(--fw-semibold); }
.consent__btn--ghost { background: transparent; color: #fff; border: 1px solid rgba(255,255,255,.4); }
.consent__btn--solid { background: #fff; color: #0a0e1f; }

.rise-enter-active, .rise-leave-active { transition: transform var(--d-med) var(--ease-out); }
.rise-enter-from, .rise-leave-to { transform: translateY(100%); }
</style>
